import { useState, useEffect } from 'react';
import { emailAccountsService } from '../services/emailAccountsService';

export function useEmailAccounts() {
    const [accounts, setAccounts] = useState([]);
    const [selectedAccount, setSelectedAccount] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchAccounts();
    }, []);

    const fetchAccounts = async () => {
        try {
            setLoading(true);
            const data = await emailAccountsService.getAll();
            setAccounts(data);

            // Set default account as selected
            if (data.length > 0 && !selectedAccount) {
                const defaultAccount = data.find(acc => acc.id === 'default') || data[0];
                setSelectedAccount(defaultAccount);
            }
        } catch (err) {
            console.error('Error fetching accounts:', err);
        } finally {
            setLoading(false);
        }
    };

    const refreshAccounts = () => {
        return fetchAccounts();
    };

    return {
        accounts,
        selectedAccount,
        setSelectedAccount,
        loading,
        refreshAccounts
    };
}
